const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Tempo trascorso dall'apertura, compatto come nella coda del prototipo: «adesso», «18 min»,
 * «3 h», «5 g», oltre i due mesi «4 mesi». Un istante futuro (orologi non allineati) vale «adesso».
 */
export function formatElapsed(fromIso: string, now: Date = new Date()): string {
  const elapsed = now.getTime() - new Date(fromIso).getTime();
  if (elapsed < MINUTE) return 'adesso';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)} h`;
  const days = Math.floor(elapsed / DAY);
  if (days < 60) return `${days} g`;
  return `${Math.floor(days / 30)} mesi`;
}

/** Il fuso della console: date e ore si leggono sempre all'ora italiana. */
const ROME = 'Europe/Rome';

const dateTime = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: ROME,
});

/** Data e ora in italiano, fuso di Roma: «30/09/2026, 10:00». */
export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

const time = new Intl.DateTimeFormat('it-IT', { hour: '2-digit', minute: '2-digit', timeZone: ROME });
const dayMonth = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', timeZone: ROME });
const dayMonthYear = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: ROME,
});
const calendarDay = new Intl.DateTimeFormat('en-CA', { timeZone: ROME });
const calendarYear = new Intl.DateTimeFormat('en-CA', { year: 'numeric', timeZone: ROME });

/**
 * Quando, in breve, nel fuso di Roma: l'ora se è oggi («14:32»), altrimenti la data («15/10», con
 * l'anno se non è quello in corso: «30/12/2025»). Per «Risposta ricevuta · …» in coda (#122).
 */
export function formatTimeOrDate(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  if (calendarDay.format(at) === calendarDay.format(now)) return time.format(at);
  return calendarYear.format(at) === calendarYear.format(now) ? dayMonth.format(at) : dayMonthYear.format(at);
}
